import React from 'react';
import styled from 'styled-components';
import StateEnum from './ProgressStateEnum';

const Bar = styled.div`
    width: 100%;
    height: 10px;
    margin: 10px 0px;
`;

const LabelWrapper = styled.div`
    width: 100%;
    text-align: center;
`;

interface ProgressBarProps
{
    label: string;
    isCurrent?: boolean;
    isComplete?: boolean;
    isError?: boolean;
}

const ProgressBarComponent = ({label, isCurrent, isComplete, isError}: ProgressBarProps) => {
    
    return(
        <div>
            <Bar className={'package-progress-bar' + (isCurrent ? ' current' : '') +  (isComplete ? ' complete' : '') + (isError ? ' error' : '')} />
            <LabelWrapper>
                {isCurrent ? <strong>{label}</strong> : label}
            </LabelWrapper>
        </div>
    );
}

export default ProgressBarComponent;